import React from "react";

import { Divider, Header, Label } from "semantic-ui-react";

import { useFeatures } from "components/FeatureFlag";

import { useWorkDeskEnabled } from "scenes/Hubly/components/Workspace/components/hooks";

import { useUpdateWorkDeskPreference } from "./hooks";
import ExperimentToggle from "./ExperimentToggle";

function ExperimentsSettings() {
  const workDesk = useFeatures("work-desk-toggle-switch");
  const workDeskEnabled = useWorkDeskEnabled();
  const { isUpdating, updateWorkDeskPreference } =
    useUpdateWorkDeskPreference();

  if (!workDesk?.enabled) return null;

  return (
    <React.Fragment>
      <Divider style={{ marginTop: "2em", marginBottom: "1em" }} />
      <div style={{ marginTop: "1em" }} data-test="experiments-settings">
        <Header as="h1" style={{ marginBottom: "0" }}>
          Experiments
          <Label
            basic
            horizontal
            data-test="experiments-beta-sign"
            style={{
              marginLeft: "0.75em",
              verticalAlign: "middle",
              color: "#e2923a",
            }}
          >
            Beta
          </Label>
        </Header>
        <ExperimentToggle
          settingKey="work-desk"
          title={workDesk.title}
          message={workDesk.message}
          toggleLabel={workDesk.toggleLabel}
          helperText={workDesk.onHelperText}
          checked={workDeskEnabled}
          loading={isUpdating}
          onChange={updateWorkDeskPreference}
        />
      </div>
    </React.Fragment>
  );
}

export default ExperimentsSettings;
